import ReportCard from "../../../../components/ReportCard";
import {
  REPORT_GROUPS,
  getItemsInGroup,
} from "../../../../config/reportLibrary";

/**
 * Renders the library of reports as a grid of ReportCard,
 * organised by groups (Hoạt động / Hiệu suất / Bán hàng).
 *
 * `hints` is a map of item.id → React node for optional mini-preview text.
 */
const ReportLibraryGrid = ({ hints = {} }) => (
  <div className="space-y-5">
    {REPORT_GROUPS.map((group) => {
      const items = getItemsInGroup(group.id);
      if (items.length === 0) return null;
      return (
        <div key={group.id}>
          <div className="flex items-baseline justify-between mb-2">
            <h3 className="text-xs font-semibold uppercase tracking-wider text-gray-500">
              {group.label}
            </h3>
            <span className="text-[11px] text-gray-400">
              {items.filter((it) => it.status === "live").length} báo cáo
            </span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {items.map((item) => (
              <ReportCard
                key={item.id}
                item={item}
                hint={hints[item.id]}
              />
            ))}
          </div>
        </div>
      );
    })}
  </div>
);

export default ReportLibraryGrid;
